import { render } from "./MetalPlayer.vue?vue&type=template&id=363a3657&scoped=true"
import script from "./MetalPlayer.vue?vue&type=script&lang=js"
export * from "./MetalPlayer.vue?vue&type=script&lang=js"

import "./MetalPlayer.vue?vue&type=style&index=0&id=363a3657&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-363a3657"]])

export default __exports__